import { render, staticRenderFns } from "./FiltersCollection.vue?vue&type=template&id=876f871c&scoped=true"
import script from "./FiltersCollection.vue?vue&type=script&lang=js"
export * from "./FiltersCollection.vue?vue&type=script&lang=js"
import style0 from "./FiltersCollection.vue?vue&type=style&index=0&id=876f871c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f871c",
  null
  
)

export default component.exports